import createReducer from '../config/create_reducer';
import Const, { orderTypeToCorrectType } from '../config/const';

const getDefaultState = () => ({
  loading: false,
  error: null
});

const orderDetailsReducer = createReducer(getDefaultState(), {
  [Const.orderDetails.loading]: (state) => ({
    ...state,
    loading: true
  }),
  [Const.orderDetails.updated]: (state, { orderDetails }) => ({
    ...state,
    loading: false,
    [orderDetails.id]: {
      ...state[orderDetails.id],
      ...orderDetails,
      orderType: orderTypeToCorrectType[orderDetails.orderType]
    }
  }),
  [Const.orderDetails.clear]: () => ({
    ...getDefaultState()
  }),
  [Const.logOut.clear]: () => ({
    ...getDefaultState()
  }),
  [Const.orderDetails.sendedOrderReviewError]: (state, { error }) => ({
    ...state,
    error,
    loading: false
  }),
  [Const.orderDetails.sendedOrderReviewClearError]: (state) => ({
    ...state,
    error: null
  }),
  [Const.applicationError.clearError]: (state) => ({
    ...state,
    loading: false
  })
});

export default orderDetailsReducer;
